import Corpus from './core';

var tabs = {
    init: function ( el, options ) {
        var defaults = {
                controls: '.tab-navigation',
                panel: '.tab-panel',
                active_class: 'selected',
                enable_hash: false,
                active_tab: null,
                effect: null,
                triggerEvent: 'click'
            },
            options = options || {},
            results = {};

        $( el ).each( function () {
            var $el = $( this ),
                opt = $.extend( {}, defaults, options, Corpus.parse_options( $el.data( 'options' ) ) ),
                control = $el.find( opt.controls ),
                tabPanel = $el.find( opt.panel ),
                tabs = tabPanel.children(),
                active_tab_name,
                active_class = opt.active_class;

            function get_index ( tab_name ) {
                return tabs.index( tabs.filter( '[data-tab="' + tab_name + '"]' ) );
            }

            $( this ).find( opt.controls ).on( opt.triggerEvent, 'li', function ( e ) {
                e.preventDefault();
                var target = $( this ),
                    tab_name = target.attr( 'data-tab' );

                if ( active_tab_name !== tab_name ) {
                    // set active tab and trigger update events
                    active_tab_name = tab_name;

                    control.trigger( {
                        type: 'corpus.tab.change.control',
                        tab_name: tab_name,
                        index: get_index( tab_name )
                    } );

                    // fire events for other modules that have subscribed that are bound to this same node
                    tabPanel.trigger( {
                        type: 'corpus.tab.change.panel',
                        tab_name: tab_name,
                        index: get_index( tab_name )
                    } );
                }
            } );

            // listen for change when tab panel is paired with a carousel and update active control accordingly
            tabPanel.on( 'corpus.carousel.change', function ( e ) {
                var tab_name = control.find( '> li' ).eq( e.index ).data( 'tab' );
                control.trigger( {
                    type: 'corpus.tab.change.control',
                    tab_name: tab_name,
                    index: get_index( tab_name )
                } );
            } );

            // update active tab tabPanel
            control.on( 'corpus.tab.change.control', function ( e ) {
                control.find( '> li' ).removeClass( active_class );
                control.find( '[data-tab="' + e.tab_name + '"]' ).addClass( active_class );
            } );

            // change tab
            control.on( 'corpus.tab.change.control', function ( e ) {
                tabPanel.find( '[data-tab]' ).removeClass( active_class );
                tabPanel.find( '[data-tab="' + e.tab_name + '"]' ).addClass( active_class );
            } );

            if ( opt.enable_hash ) {
                control.bind( 'corpus.tab.change.control', function ( e ) {
                    window.location.hash = e.tab_name;
                } );

                // change tab when a new hash is applied
                $( window ).bind( 'hashchange', function ( e ) {
                    var tab_name = window.location.hash.slice( 1 );
                    control.trigger( {
                        type: 'corpus.tab.change.control',
                        tab_name: tab_name,
                        index: get_index( tab_name )
                    } );
                } );
            }

            // activate first tab
            if ( opt.active_tab !== 'none' ) {
                active_tab_name = control.find( '[data-tab="' + opt.active_tab + '"], .' + opt.active_class );
                active_tab_name = (typeof active_tab_name[0] !== 'undefined')
                    ? active_tab_name.attr( 'data-tab' )
                    : control.find( '[data-tab]:first' ).attr( 'data-tab' );

                control.trigger( {
                    type: 'corpus.tab.change.control',
                    tab_name: active_tab_name,
                    index: get_index( active_tab_name )
                } );
            }

            results[this.id] = control;
        } );

        return results;
    }

};

Corpus.modules.tabs = (function () {

    return {
        name: 'tabs', version: '0.0.1',

        // public initializer
        init: function ( scope, options ) {
            options = options || {};

            var classList = '.tab-set, .tabset, .tabSet';

            $( 'html' ).addClass( 'js-tabs' );

            var $tabs = ($( scope ).is( classList ) || options.scopeIsTarget)
                ? $( scope )
                : $( scope ).find( classList );

            $tabs.each( function ( index, el ) {
                // create a scoped instance for initialization
                var scoped_module = Object.create( tabs );
                scoped_module.init( el, options );
            }.bind( this ) );

            return this;
        }
    };

}());

export default Corpus.modules.tabs;
